// @flow
import type { Location } from '../types'
import { domain } from './domain'

export const pushLocation = domain.createEvent<Location>('push location')
